"use client";

import React from "react";
import AniIcon from "./AniIcon";

const AniCheckbox = ({
  checked,
  onChange,
  label,
}: {
  checked: boolean;
  onChange: (next: boolean) => void;
  label: string;
}) => (
  <label className="ani-checkbox" data-token="Ani Checkbox" data-gap="spacing/xs">
    <input
      type="checkbox"
      checked={checked}
      onChange={(event) => onChange(event.target.checked)}
    />
    <span data-token="Checkbox control" className="ani-checkbox-box ani-tint">
      <AniIcon name="check" />
    </span>
    <span className="ani-checkbox-label" data-token="Ani Label">{label}</span>
  </label>
);

export default AniCheckbox;
